import { PERMISSIONS as EPIC_PERMISSIONS } from '../EpicAdministration/_const';

export const PERMISSIONS = {
	IMS_ROLE: EPIC_PERMISSIONS.IMS_ROLE,
	ECL_ROLE: 1752,
	ECL_PRIVILEGE: 140974,
};
